import UAParser from 'ua-parser-js';
import { v5 as uuidv5 } from 'uuid';
import AES from 'crypto-js/aes';
import encUtf8 from 'crypto-js/enc-utf8';
import { getEKey } from './helpers';

export const monthShortNames: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const { device, os, browser } = new UAParser().getResult();

const STORED_DEV_ID_KEY = 'APP_DEV_ID';
const E_KEY = getEKey();

export const LONGITUDE = 1.222; // todo
export const LATITUDE = 2.23333; // todo
export const LANGUAGE_CODE = '1';
export const COUNTRY_CODE = '1';
export const APP_CHANNEL = 'INTERNET-BANKING';
export const APP_VERSION = '1.2';
export const DEVICE_NAME = device.vendor ? device.vendor : os.name || 'Unknown';
export const DEVICE_MODEL = device.model ? device.model : `${browser.name || 'Unknown'} ${browser.version || ''}`;

export const DEVICE_ID: string = ((): string => {
  const storedDeviceId = localStorage.getItem(STORED_DEV_ID_KEY);
  if (storedDeviceId) {
    try {
      const decryptedId = AES.decrypt(storedDeviceId, E_KEY).toString(encUtf8);
      if (decryptedId) return decryptedId;
    } catch (err) {
      console.error(err);
    }
  }

  const newId = uuidv5(DEVICE_NAME + DEVICE_MODEL + Date.now().toString(), uuidv5.URL);
  const encryptedNewId = AES.encrypt(newId, E_KEY).toString();
  localStorage.setItem(STORED_DEV_ID_KEY, encryptedNewId);
  return newId;
})();

export const ACCOUNT_LENGTHS = [10, 13, 16];
export const MAX_ACCOUNT_LENGTH = Math.max(...ACCOUNT_LENGTHS);

export const PHONE_LENGTH = 10;
export const PHONE_LENGTH_BUSY = 6;
export const PHONE_LENGTH_SURF_MAX = 12;

export const PASSWORD_REGEX = /((?=.*[^\d\w]){1})(?=.*\d)((?=.*[A-Z]){1}).*$/g;

export const NETWORK_REQUIRED = 'Cannot sign-in, network connection required';

export const PIN_BLOCKED_MSG = 'Transaction Pin validation failed. Your pin has been blocked';

export const PROFILE_INACTIVE_MSG = 'Your profile is not active. Please contact the bank.';

export const SESSION_TIMEOUT_MSG = 'You will be logged out due to one more login to your profile.';

export const CONTACT_CENTER_EMAIL = 'contactcenter@firstatlanticbank.com.gh' as const;

export const DEFAULT_ACCOUNT_TYPE = 'ATLANTIC SAVE';

export const socialLinks = {
  facebook: 'https://www.facebook.com/FirstAtlanticBank/',
  instagram: 'https://instagram.com/firstatlanticgh',
  twitter: 'https://twitter.com/FirstAtlanticGH',
  linkedin: 'https://www.linkedin.com/company/first-atlantic-bank-ghana',
};

export const TransferFrequencyList = [
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
  },
  {
    label: 'Special Date',
    value: 'specialDate',
  },
];
export const FABSORTCODE = 170101;
